import React from "react";
import { motion } from "framer-motion";

// Animated ecosystem flywheel: center AI core orbited by Creators, Viewers, Advertisers
export default function EcosystemFlywheel() {
  const nodes = [
    { label: "CREATORS", angle: -90, color: "#f8fafc" },
    { label: "VIEWERS", angle: 30, color: "#f8fafc" },
    { label: "ADVERTISERS", angle: 150, color: "#f8fafc" },
  ];

  const R = 170; // orbit radius
  const cx = 250;
  const cy = 250;

  return (
    <div className="relative w-full aspect-square max-w-[640px] mx-auto">
      {/* outer glow */}
      <div className="absolute inset-4 rounded-full bg-violet-700/20 blur-3xl" />
      <div className="absolute inset-12 rounded-full bg-purple-500/15 blur-2xl" />

      <svg
        viewBox="0 0 500 500"
        className="relative w-full h-full"
        data-testid="hero-flywheel-svg"
      >
        <defs>
          <radialGradient id="coreGrad" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#a855f7" stopOpacity="0.9" />
            <stop offset="50%" stopColor="#7c3aed" stopOpacity="0.4" />
            <stop offset="100%" stopColor="#000000" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="lineGrad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#7c3aed" stopOpacity="0" />
            <stop offset="50%" stopColor="#7c3aed" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#7c3aed" stopOpacity="0" />
          </linearGradient>
        </defs>

        {/* Concentric grid rings */}
        {[60, 110, 170, 220].map((r, i) => (
          <circle
            key={r}
            cx={cx}
            cy={cy}
            r={r}
            fill="none"
            stroke="rgba(255,255,255,0.06)"
            strokeWidth="1"
            strokeDasharray={i % 2 === 0 ? "0" : "2 6"}
          />
        ))}

        {/* Cross hairs */}
        <line x1="20" y1={cy} x2="480" y2={cy} stroke="rgba(255,255,255,0.04)" />
        <line x1={cx} y1="20" x2={cx} y2="480" stroke="rgba(255,255,255,0.04)" />

        {/* Rotating orbit ring */}
        <g className="spin-slow" style={{ transformOrigin: "250px 250px" }}>
          <circle
            cx={cx}
            cy={cy}
            r={R}
            fill="none"
            stroke="url(#lineGrad)"
            strokeWidth="1.5"
            strokeDasharray="4 8"
          />
          <circle cx={cx + R} cy={cy} r="3" fill="#a855f7" />
        </g>

        {/* Reverse orbit */}
        <g className="spin-rev" style={{ transformOrigin: "250px 250px" }}>
          <circle
            cx={cx}
            cy={cy}
            r={110}
            fill="none"
            stroke="rgba(255,255,255,0.12)"
            strokeWidth="1"
            strokeDasharray="2 10"
          />
          <circle cx={cx} cy={cy - 110} r="2" fill="#ffffff" opacity="0.6" />
        </g>

        {/* Connector lines from center to nodes */}
        {nodes.map((n) => {
          const rad = (n.angle * Math.PI) / 180;
          const x = cx + Math.cos(rad) * R;
          const y = cy + Math.sin(rad) * R;
          return (
            <line
              key={n.label}
              x1={cx}
              y1={cy}
              x2={x}
              y2={y}
              stroke="rgba(234,88,12,0.35)"
              strokeWidth="1"
              strokeDasharray="2 4"
            />
          );
        })}

        {/* Center AI core */}
        <circle cx={cx} cy={cy} r="92" fill="url(#coreGrad)" className="animate-pulse-glow" />
        <circle cx={cx} cy={cy} r="58" fill="#000000" stroke="rgba(255,255,255,0.45)" strokeWidth="1" />
        <circle cx={cx} cy={cy} r="58" fill="none" stroke="#7c3aed" strokeWidth="1.2" strokeDasharray="100 250" className="orbit-dash" />
        <text x={cx} y={cy - 6} textAnchor="middle" fill="#a78bfa" fontSize="9" fontFamily="JetBrains Mono" letterSpacing="3">
          F3
        </text>
        <text x={cx} y={cy + 14} textAnchor="middle" fill="#ffffff" fontSize="15" fontFamily="PT Serif" fontStyle="italic">
          Media
        </text>

        {/* Orbital nodes */}
        {nodes.map((n, idx) => {
          const rad = (n.angle * Math.PI) / 180;
          const x = cx + Math.cos(rad) * R;
          const y = cy + Math.sin(rad) * R;
          return (
            <g key={n.label}>
              <circle cx={x} cy={y} r="28" fill="#0a0a0a" stroke="rgba(255,255,255,0.3)" strokeWidth="1" />
              <circle cx={x} cy={y} r="5" fill={n.color} />
              <text
                x={x}
                y={y + 50}
                textAnchor="middle"
                fill="#c4b5fd"
                fontSize="10"
                fontFamily="JetBrains Mono"
                letterSpacing="2"
              >
                {n.label}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}
